import { checkPermission } from '@/router/guards.ts'

const AnnouncementModule = () => import('./AnnouncementModule.vue')
const AnnouncementIndex = () => import('./views/AnnouncementIndex.vue')

export const announcementRoute = {
  path: '/announcements',
  name: 'announcement',
  component: AnnouncementModule,
  meta: {
    title: 'Announcements',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'announcements-index',
      component: AnnouncementIndex,
      meta: {
        permission: 'announcement.view',
      },
      beforeEnter: checkPermission('announcement.view'),
    },
  ],
}
